import { render, staticRenderFns } from "./areaTest.vue?vue&type=template&id=4d2c4bec&"
import script from "./areaTest.vue?vue&type=script&lang=ts&"
export * from "./areaTest.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports